var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics-container"},[_c('div',{staticClass:"enterprise-container"},[_c('el-empty',{attrs:{"description":"暂无数据"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }